import mainLogo from '../../images/Vigorito/vigorito_logo_color_branco.png';
import squareLogo from '../../images/Vigorito/vigorito_logo_color_square.png';
import mainLogoWhite from '../../images/Vigorito/vigorito_logo_color_branco.png';
import banner01 from '../../images/Vigorito/concessionaria_faixa_vigorito_vw.webp';
import banner02 from '../../images/Vigorito/concessionaria_faixa_vigorito_nissan_2.webp';
import banner03 from '../../images/Vigorito/concessionaria_faixa_vigorito_nissan.webp';
import banner04 from '../../images/Vigorito/concessionaria_faixa_vigorito_vw_2.webp';
import banner05 from '../../images/Vigorito/concessionaria_faixa_vigorito_nissan.webp';
import bannerImg05 from '../../images/Vigorito/vigorito_kits_bannerImg.webp';
import bannerBrands from '../../images/Vigorito/carros_faixa_VigoritoBrands.jpg';
import car123 from '../../images/Vigorito/123_virtus.jpg';
import box123 from '../../images/Vigorito/123_vigo.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

import vigo100anosBannerBGDesktop from '../../images/Vigorito/vigo_100anos_bg_desk_01.jpg';
import vigo100anosBannerBGMobile from '../../images/Vigorito/vigo_100anos_arte_square_01.jpg';
import vigo100anosBannerImg from '../../images/Vigorito/vigo_100anos_arte_desk_02.png';
import vigo100anosBannerImgMobile from '../../images/Vigorito/vigo_100anos_arte_mobile_03.png';

export const configData = {
    defaultStore: 'Vigorito',
    defaultStoreLink: 'vigoritopecas.com.br',
    defaultContactEmail: 'ecommerce@vigorito.com.br',
    whatsappNumber: '11 4478 2465',
    CNPJ: '46.923.934/0013-30',
    CNPJname: 'Felicio Vigorito & Filhos LTDA',
    CNPJaddress: 'Rua Moreira de Godoi, 131 - Galpão A - Ipiranga, São Paulo - SP, 04.266-060',
    launchDate: '07/09/2024',

    multiContact: {
        // 'Falar com vendedor (whatsapp: 11 99382 3411)': '11 99382 3411',
        // 'Falar com vendedor (fixo: 11 4478-2465)': '11 4478 2465',
        // 'Trocas ou devoluções (whatsapp: 11 93465 3429)': '11 93465 3429',
        
        'Telefone fixo: 11 4478-2465': '11 4478 2465',
        'Whatsapp: 11 93465 3429': '11 93465 3429',
    },
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'chevrolet',
        'kia',
        'nissan',
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "VIGORITO VW ATACADO",
        "VIGORITO NISSAN ATACADO",
        "VIGORITO KIA",
        "VIGORITO GM ATACADO",
        // 'VIGORITO VW SAO BERNARDO',
        // 'VIGORITO VW MAUA',
        // 'VIGORITO VW VILA MARIANA',
        // 'VIGORITO NISSAN PENHA',
        // 'VIGORITO NISSAN GUARULHOS',
        // 'VIGORITO KIA ARICANDUVA',
    ],
    
    disabledSellers: [
        'VIGORITO VW SAO BERNARDO',
        'VIGORITO VW MAUA',
        'VIGORITO VW VILA MARIANA',
        'VIGORITO NISSAN PENHA',
        'VIGORITO NISSAN GUARULHOS',
        'VIGORITO KIA ARICANDUVA',
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 4,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            1000: 4,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    banner05: banner05,
    bannerBrands: bannerBrands,
    aboutUsBg: banner04,
    bannerImg01: mainLogoWhite,
    bannerImg05: bannerImg05,

    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: vigo100anosBannerBGDesktop,
    bannerSpecialMobile: vigo100anosBannerBGMobile,
    imgSepcial: vigo100anosBannerImg,
    imgSepcialMobile: vigo100anosBannerImgMobile,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias <mark>Vigorito</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'Criada em 1925, a Vigorito é a primeira Chevrolet do Brasil, fundada logo após a chegada da General Motors no Brasil.',
            'Graças à competência, ao fortalecimento, à seriedade e à qualidade na venda de veículos e serviços prestados, o Grupo Vigorito expandiu-se, inaugurando unidades da concessionária nos municípios de Santo André, Mauá e também no Aricanduva, na Saúde e no Ipiranga, além da grandiosa edificação em São Mateus, que atende o atacado e varejo de todas as marcas com amplo estoque de peças originais.',
            'E o crescimento não parou por aí, antes de completar seus 90 anos de existência, passou a representar também, com mais duas unidades na regiões de Guarulhos e Penha, a marca japonesa Nissan, denominada Nissan Kin. Outras duas filiais da marca coreana Kia, com a Kia Vig em Guarulhos e no Shopping Aricanduva. E mais duas unidades da marca alemã Volkswagen, a Vigo Motors nas cidades de São Bernardo do Campo e Mauá.'
        ],
        link: 'https://vigorito.com.br/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupo_vigorito/',
        Facebook: 'https://www.facebook.com/grupovigorito/?locale=pt_BR',
        LinkedIn: 'https://br.linkedin.com/company/grupo-vigorito',
        Youtube: 'https://www.youtube.com/channel/UCLSUn0V-d3YJjZD5jF6exAw',
        Twitter: '',
    },

    footerContent: [],
}